module.exports = __webpack_public_path__ + "static/img/v-m29.32d8773.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/v-m29.png
// module id = X4Nr
// module chunks = 0